const actions = {
    GET_DATA: "vehicles/GET_DATA",
    SET_DATA: "vehicles/SET_DATA",

    GET_LOCATION: "vehicles/GET_LOCATION",
    SET_LOCATION: "vehicles/SET_LOCATION",

    GET_VEHICLE_DETAILS: "vehicles/GET_VEHICLE_DETAILS",
    SET_VEHICLE_DETAILS: "vehicles/SET_VEHICLE_DETAILS",

    GET_PIN_DETAILS: "vehicles/GET_PIN_DETAILS",
    SET_PIN_DETAILS: "vehicles/SET_PIN_DETAILS",

    SET_INITIAL: "vehicles/SET_INITIAL",
    SET_INITIAL_PINS: 'vehicles/SET_INITIAL_PINS',
    SET_INITIAL_VEHICLES_SEARCH: "vehicles/SET_INITIAL_VEHICLES_SEARCH",
    SET_INITIAL_VEHICLE_LOCATION_DETAILS: "vehicles/SET_INITIAL_VEHICLE_LOCATION_DETAILS",

    GET_VEHICLES_LOCATIONS: "vehicles/GET_VEHICLES_LOCATIONS",
    SET_VEHICLES_LOCATIONS: "vehicles/SET_VEHICLES_LOCATIONS",
    SET_VEHICLES_REFRESH: "vehicles/SET_VEHICLES_REFRESH",
    SET_INITIAL_VEHICLES_LOCATION : "vehicles/SET_INITIAL_VEHICLES_LOCATION",

    GET_VEHICLE_LOCATION_DETAILS: "vehicles/GET_VEHICLE_LOCATION_DETAILS",
    SET_VEHICLE_LOCATION_DETAILS: "vehicles/SET_VEHICLE_LOCATION_DETAILS",

    GET_VEHICLES_SEARCH: "vehicles/GET_VEHICLES_SEARCH",
    SET_VEHICLES_SEARCH: "vehicles/SET_VEHICLES_SEARCH",

    GET_VEHICLE_START_STOP: "vehicles/GET_VEHICLE_START_STOP",
    SET_VEHICLE_START_STOP: "vehicles/SET_VEHICLE_START_STOP",

    GET_VEHICLE_NEW_START_STOP: "vehicles/GET_VEHICLE_NEW_START_STOP",
    SET_VEHICLE_NEW_START_STOP: "vehicles/SET_VEHICLE_NEW_START_STOP",

    GET_USER_POI: "vehicles/GET_USER_POI",
    SET_USER_POI: "vehicles/SET_USER_POI",

    GET_USER_POI_DETAILS: "vehicles/GET_USER_POI/DETAILS",
    SET_USER_POI_DETAILS: "vehicles/SET_USER_POI_DETAILS",
    SET_INITIAL_NEW_POI: "vehicles/SET_INITIAL_NEW_POI",

    GET_CUSTOMER_POI: "vehicles/GET_CUSTOMER_POI",
    SET_CUSTOMER_POI: "vehicles/SET_CUSTOMER_POI",

    GET_CUSTOMER_POI_DETAILS: "vehicles/GET_CUSTOMER_POI_DETAILS",
    SET_CUSTOMER_POI_DETAILS: "vehicles/SET_CUSTOMER_POI_DETAILS",
    SET_INITIAL_CUSTOMER_POI_DETAILS: "vehicles/SET_INITIAL_CUSTOMER_POI_DETAILS",

    GET_VEHICLE_RPM: "vehicles/GET_VEHICLE_RPM",
    SET_VEHICLE_RPM: "vehicles/SET_VEHICLE_RPM",

    GET_VEHICLES_CONFIGURATION: `vehicles/GET_VEHICLE_CONFIGURATION`,
    SET_VEHICLES_CONFIGURATION: `vehicles/SET_VEHICLE_CONFIGURATION`,

    GET_VEHICLES_GROUP: "vehicles/GET_VEHICLES_GROUP",
    SET_VEHICLES_GROUP: "vehicles/SET_VEHICLES_GROUP",

    GET_VEHICLE_DETAILS_GROUP: 'vehicles/GET_VEHICLE_DETAILS_GROUP',
    SET_VEHICLE_DETAILS_GROUP: 'vehicles/SET_VEHICLE_DETAILS_GROUP',

    GET_VEHICLE_GROUPS: "vehicles/GET_VEHICLE_GROUPS",
    SET_VEHICLE_GROUPS: "vehicles/SET_VEHICLE_GROUPS",

    GET_VEHICLES_UNGROUPED: "vehicles/GET_VEHICLES_UNGROUPED",
    SET_VEHICLES_UNGROUPED: "vehicles/SET_VEHICLES_UNGROUPED",

    GET_VEHICLES_FUEL_TANK_VEHICLE: "vehicles/GET_VEHICLES_FUEL_TANK_VEHICLE",
    SET_VEHICLES_FUEL_TANK_VEHICLE: "vehicles/SET_VEHICLES_FUEL_TANK_VEHICLE",

    GET_VEHICLES_FUEL_TANK_VEHICLE_COMBINED: "vehicles/GET_VEHICLES_FUEL_TANK_VEHICLE_COMBINED",
    SET_VEHICLES_FUEL_TANK_VEHICLE_COMBINED: "vehicles/SET_VEHICLES_FUEL_TANK_VEHICLE_COMBINED",

    GET_VEHICLE_DISTURBANCE_REFUEL: "vehicles/GET_VEHICLE_DISTURBANCE_REFUEL",
    SET_VEHICLE_DISTURBANCE_REFUEL: "vehicles/SET_VEHICLE_DISTURBANCE_REFUEL",

    GET_VEHICLE_DISTURBANCE_LOSS: "vehicles/GET_VEHICLE_DISTURBANCE_LOSS",
    SET_VEHICLE_DISTURBANCE_LOSS: "vehicles/SET_VEHICLE_DISTURBANCE_LOSS",

    GET_VEHICLES_WITH_CONFIG: "vehicles/GET_VEHICLES_WITH_CONFIG",
    SET_VEHICLES_WITH_CONFIG: "vehicles/SET_VEHICLES_WITH_CONFIG",

    SET_INITIAL_VEHICLES_WITH_CONFIG: "vehicles/SET_INITIAL_VEHICLES_WITH_CONFIG",

    GET_TELEMETRY_PDF: "vehicles/GET_TELEMETRY_PDF",
    GET_ROUTE_REPORT_PDF: "vehicles/GET_ROUTE_REPORT_PDF",

    GET_BOTTOM_OF_TOP_BAR: "vehicles/GET_BOTTOM_OF_TOP_BAR",
    SET_BOTTOM_OF_TOP_BAR: "vehicles/SET_BOTTOM_OF_TOP_BAR",

    SET_PDF_LOADING: 'vehicles/SET_PDF_LOADING',
};

export default actions;